const header = document.querySelector('.site-header');
const toggle = document.querySelector('.menu-toggle');

toggle?.addEventListener('click', () => {
  const isOpen = header.classList.toggle('open');
  toggle.setAttribute('aria-expanded', String(isOpen));
});

document.querySelectorAll('nav a').forEach((link) => link.addEventListener('click', () => {
  header.classList.remove('open');
  toggle?.setAttribute('aria-expanded', 'false');
}));

document.querySelectorAll('.book img').forEach((image) => {
  const revealCover = () => {
    if (image.naturalWidth) image.closest('.book')?.classList.add('has-cover');
  };
  image.addEventListener('load', revealCover);
  revealCover();
});

const days = document.querySelector('.days');
const daysPrev = document.querySelector('[data-days-prev]');
const daysNext = document.querySelector('[data-days-next]');

if (days) {
  const updateDaysControls = () => {
    const end = days.scrollWidth - days.clientWidth;
    if (daysPrev) daysPrev.disabled = days.scrollLeft <= 2;
    if (daysNext) daysNext.disabled = days.scrollLeft >= end - 2;
  };

  const moveDays = (direction) => days.scrollBy({
    left: direction * Math.max(245, days.clientWidth * .72),
    behavior: 'smooth'
  });

  daysPrev?.addEventListener('click', () => moveDays(-1));
  daysNext?.addEventListener('click', () => moveDays(1));
  days.addEventListener('scroll', updateDaysControls, { passive: true });
  window.addEventListener('resize', updateDaysControls);

  days.addEventListener('wheel', (event) => {
    if (Math.abs(event.deltaY) <= Math.abs(event.deltaX)) return;
    const end = days.scrollWidth - days.clientWidth;
    const canMove = event.deltaY > 0 ? days.scrollLeft < end - 2 : days.scrollLeft > 2;
    if (!canMove) return;
    event.preventDefault();
    days.scrollLeft += event.deltaY;
  }, { passive: false });

  updateDaysControls();
}
